<div class="bg_image">
  <div class="pt-5">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
      <img src="assets\img\logo\eReturn_Logo.svg" class="ereturn-logo">
    </div>
  </div>
  <div class="mt-5 mb-4">
    <div class="col-12 text-center">
      <h5><strong>eReturn email verification to reset password for NRB</strong></h5>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-12" style="font-family: Solaiman Lipi !important">

        <div class="mb-4">
          <div>
            <div style="width:40px"></div>
            <div>অনেক প্রবাসী করদাতা বাংলাদেশের মোবাইল ফোন ব্যবহার করে ইতোমধ্যে ই-রিটার্ন সিস্টেমে রেজিস্ট্রেশন করেছেন।
              কিন্তু বর্তমানে বিদেশে অবস্থানকালে বাংলাদেশের মোবাইল ফোন ব্যবহার করতে পারছেন না। ফলে ই-রিটার্ন পাসওয়ার্ড
              ভুলে গেলে তা রিসেট করতে পারছেন না। এরুপ করদাতারা <b> টিআইএন, বসবাসরত দেশের নাম, ঠিকানা ও মোবাইল/ফোন নম্বর,
                বাংলাদেশ ত্যাগের সর্বশেষ তারিখ, ইমেইল উল্লেখপূর্বক জাতীয় পরিচয় পত্র, পাসপোর্ট ও ভিসার কপি </b> সংযুক্ত
              করে Sample email verification application ফরম্যাট অনুসারে জাতীয় রাজস্ব বোর্ডের নিকট নিজের email হতে আবেদন
              করে ভেরিফিকেশন সম্পন্ন হলে email এ প্রাপ্ত OTP ব্যবহার করে পাসওয়ার্ড রিসেট করতে পারবেন।
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div>
            <div style="width:40px"></div>
            <div>বিদেশে অবস্থানরত বাংলাদেশিদের জন্য মোবাইল ফোন নম্বরের পরিবর্তে email ব্যবহার করে ইমেইল ভেরিফিকেশনের
              জন্য উপরিউক্ত তথ্য ও প্রমাণ আবশ্যক।
              <b> কোন তথ্য ঘাটতি থাকলে বা ফরম্যাট অনুসারে আবেদন না করলে করদাতার নিবন্ধন অনুমোদযোগ্য হবে না। </b></div>
          </div>
        </div>

        <div class="registration-procedure mb-4">
          <p><strong>email ভেরিফিকেশন পদ্ধতিঃ</strong></p>
          <ul class="centered-list">
            <li>করদাতা উপরিউক্ত তথ্য ও প্রমাণ সংযুক্ত করে ফরম্যাট অনুসারে <span
              style="color: blue;"><i>ereturn&#64;etaxnbr.gov.bd</i></span> email এর মাধ্যমে জাতীয় রাজস্ব বোর্ড বরাবর আবেদন
              করবেন।
            </li>
            <li>জাতীয় রাজস্ব বোর্ড, করদাতার আবেদন পরীক্ষান্তে অনুমোদনপূর্বক email ভেরিফাই করলে করদাতা email এ নোটিফিকেশন
              পাবেন।
            </li>
            <li>এরপর করদাতা Forget Password অপশনে ক্লিক করলে তাঁর টিআইএন এবং email টাইপ করে <b>verify</b> বাটনে ক্লিক
              করলে করদাতার email এ OTP যাবে যা ব্যবহার করে তিনি Password রিসেট করতে পারবেন।
            </li>
          </ul>
          <p><b><i>(email Inbox এ নোটিফিকেশন না পেলে Spam folder চেক করার অনুরোধ করা হলো)</i></b></p>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5 mb-4">
    <div class="col-12 text-center">
      <h5><strong>Sample application for email verification to reset password for NRB</strong></h5>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-12" style="font-family: Solaiman Lipi !important">

        <div class="mb-4">
          <div>
            <div>
              <p><b>To:
                <span style="color: blue; text-decoration: underline; text-decoration-color: blue;">ereturn&#64;etaxnbr.gov.bd</span>
              </b></p>

              <p>
                <b>Subject: Prayer for email verification being non-resident Bangladeshi to reset password.</b>
              </p>
              Dear Sir,<br><br>
              Greetings.<br><br>
              I am a registered taxpayer and currently living in
              <span style="color: blue;"><i>[Country Name]</i></span>. Being a non-resident Bangladeshi, I don’t have
              any Bangladeshi registered mobile phone number right now. So, I am requesting to verify my email number
              with my TIN and send e-Return registration related OTP to that mail. The required information are given
              below-
            </div>
          </div>
        </div>

        <div class="ins-list-group">
          <ul class="centered-list">
            <li>Name-</li>
            <li>TIN-</li>
            <li>Residing Country-</li>
            <li>Mail Address of the residing country-</li>
            <li>Cell phone/Phone number used in residing country-</li>
            <li>Last date of departure from Bangladesh-</li>
            <li>Email address-</li>
          </ul>

          <p>I have attached the following documents with this mail-</p>
          <ul class="centered-list">
            <li>Copy of NID/Smart ID</li>
            <li>Copy of Bio-page of Bangladeshi passport</li>
            <li>Copy of Visa page of residing country (if available)</li>
            <li>Copy of passport page with latest departure seal as proof of departure from Bangladesh.</li>
          </ul>
        </div>

        <p>I solemnly declare that the above information is true and correct. Please verify my email number with my TIN
          and allow me to update registration related data in e-Return system.</p>

        <p>Sincerely,<br>
          <span style="color: blue;"><i>[Name of Taxpayer]</i></span></p>


      </div>
    </div>
  </div>
  <div class="d-flex mt-3">
    <div class="col-12">
      <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
        <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>&nbsp;
        Back &nbsp;&nbsp;&nbsp;
      </button>
    </div>
  </div>
</div>

<ngx-ui-loader></ngx-ui-loader>
